import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";

export const createAdvanceApi = (payload) =>
  axios.post(`${API_BASE_URL}/api/advances`, payload);

export const updateAdvanceApi = (id, payload) =>
  axios.put(`${API_BASE_URL}/api/advances/${id}`, payload);

export const deleteAdvanceApi = (id) =>
  axios.delete(`${API_BASE_URL}/api/advances/${id}`);
